const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader-spinner"></div>
    </div>
  );
};

export default PageLoader;
